function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import { MetadataCodeLoadedSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { BillingConfigurationLoadedSelector } from 'invision-core/src/components/metadata/billingConfiguration/billing.configuration.selectors';
import { BILLING_CONFIGURATION_TYPES } from 'invision-core/src/components/metadata/billingConfiguration/billing.configuration.action.types';
import BillingConfigurationActions from 'invision-core/src/components/metadata/billingConfiguration/billing.configuration.actions';
import { DestinationCustomerAccountInfoViewModelSelector, DestinationCustomerAdditionalPropertiesSortedByDisplayOrderSelector, DestinationCustomerInformationViewModelSelector, IsFetchingDestinationCustomerDataSelector, SelectedDestinationCustomerSelector } from '../../../../../reducers/selectors/transfer.wizard.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { loadSubscriberRequirements } from '../../../../../reducers/helpers/subscriber.requirements.actions.helper';
var DestinationCustomerInfoController = /*#__PURE__*/function () {
  function DestinationCustomerInfoController($ngRedux, uiNotificationService) {
    _classCallCheck(this, DestinationCustomerInfoController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      uiNotificationService: uiNotificationService,
      isLoadingData: false,
      promises: [],
      requirements: {}
    });
  }
  return _createClass(DestinationCustomerInfoController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.ConvergentBillerConfigurationDetail, CODES.SubscriberCategoryRequirements, CODES.SubscriberRequirements, CODES.Currency, CODES.AddressCountry, CODES.Language, CODES.SubscriberType, CODES.InvoiceDetailLevel, CODES.AdditionalProperty, CODES.AdditionalPropertyValue, CODES.RegularExpression];
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        getInvoiceDisplay: BillingConfigurationActions.getInvoiceDisplay,
        loadSubscriberRequirements: loadSubscriberRequirements
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          commercialRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          destinationCustomerAccountInfoViewModel: DestinationCustomerAccountInfoViewModelSelector(store),
          destinationCustomerAdditionalProperties: DestinationCustomerAdditionalPropertiesSortedByDisplayOrderSelector(store),
          destinationCustomerInformationViewModel: DestinationCustomerInformationViewModelSelector(store),
          isDbss: IsDbss(store),
          isFetchingDestinationCustomerData: IsFetchingDestinationCustomerDataSelector(store),
          isInvoiceDisplayLoaded: BillingConfigurationLoadedSelector(BILLING_CONFIGURATION_TYPES.INVOICE_DISPLAY_CODE, store),
          residentialRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
          selectedDestinationCustomer: SelectedDestinationCustomerSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.promises.push(_this.actions.fetchCodeTypes(codeType));
        }
      });
      if (this.state.isDbss) {
        if (!this.state.isInvoiceDisplayLoaded) {
          this.promises.push(this.actions.getInvoiceDisplay());
        }
      }
      this.isLoadingData = true;
      Promise.all(this.promises).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
        _this.isLoadingData = false;
      }).finally(function () {
        _this.isLoadingData = false;
      });
    }
  }]);
}();
export default {
  template: require('./destination.customer.info.html'),
  controller: DestinationCustomerInfoController,
  bindings: {}
};